const { arrayOf, string, bool, shape } = require('prop-types');
const imageSpec = require('./image.spec');
const phoneSpec = require('./phone.spec');
const stateSpec = require('./state.spec');

module.exports = {
  active: bool,
  queryType: string,
  queryValue: string,
  alias: string,
  webId: string,
  clientNumber: string,
  name: string,
  type: string,
  segment: string,
  landingPage: string,
  petLink: string,
  lifeLink: string,
  mainHeading: string,
  subheading: string,
  introHeading: string,
  bodyCopy: string,
  rtbHeading: string,
  heroImage: string,
  payroll: bool,
  greeting: string,
  disclaimer: string,
  drcHours: string,
  crcHours: string,
  crcEmail: string,
  bindables: arrayOf(
    shape({
      quoteUrl: string,
      state: shape(stateSpec),
    }),
  ),
  image: shape(imageSpec),
  phones: shape(phoneSpec),
  tags: shape({
    inclusions: arrayOf(string.isRequired),
    exclusions: arrayOf(string.isRequired),
  }),
  aid: string,
};
